import { grey } from "@mui/material/colors";

const styles = {
  arrow: { fontSize: 10, ml: 1 },
  mobileList: {
    borderBottom: `1px solid ${grey[200]}`,
    py: 1,
    px: 2,
    cursor: "pointer",
  },
  children: {
    borderBottom: `1px solid ${grey[200]}`,
  },
};

export default styles;
